export default __webpack_public_path__ + "static/winter10-247a4b1d94e18ecb99150c7c39b0042a.webp";